import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Select } from "antd";
import React, { useEffect } from "react";
import "./style.css";
import { FormattedMessage, useIntl } from "react-intl";

const { Option } = Select;

const RegistryFormHeader = props => {
  const {
    contactBody,
    setContactBody,
    country,
    setCountry,
    countries,
    isEdit,
    editContactBody,
    setEditContactBody,
    editAddress,
    onEditCountry,
    onBlurTaxId,
    taxId,
    onBlurEditTaxId,
    editTaxId
  } = props;

  const intl = useIntl();

  const optionCountries = countries?.map((country, index) => {
    return (
      <Option key={index} value={country}>
        {country}
      </Option>
    );
  });

  useEffect(() => {
    if (contactBody.type === "PERSON") {
      setContactBody({
        ...contactBody,
        description: `${contactBody.firstName || ""}${
          contactBody.lastName && contactBody.lastName !== "" ? " " : ""
        }${contactBody.lastName || ""}`
      });
    }
  }, [contactBody.type, contactBody.firstName, contactBody.lastName]);

  useEffect(() => {
    if (isEdit) {
      setContactBody({ ...contactBody, type: editContactBody?.type });
    }
  }, []);

  useEffect(() => {
    if (!isEdit) {
      onBlurTaxId(taxId);
    } else {
      onBlurEditTaxId(editTaxId);
    }
  }, [contactBody.type]);

  const onClickTypePerson = () => {
    !isEdit
      ? setContactBody({ ...contactBody, type: "PERSON" })
      : setEditContactBody({ ...editContactBody, type: "PERSON" });
  };

  const onClickTypeCompany = () => {
    !isEdit
      ? setContactBody({ ...contactBody, type: "COMPANY" })
      : setEditContactBody({ ...contactBody, type: "COMPANY" });
  };

  return (
    <div className="registry-form-header">
      <div
        style={{
          width: "8%",
          display: !isEdit ? "flex" : "none",
          justifyContent: "space-between"
        }}
      >
        <div
          className={
            "registry-form-type-icon" +
            (contactBody.type === "PERSON" || editContactBody?.type === "PERSON"
              ? " active"
              : "")
          }
          style={{ cursor: "pointer" }}
          onClick={() => onClickTypePerson()}
        >
          <FontAwesomeIcon icon={["far", "user"]} />
        </div>
        <div
          className={
            "registry-form-type-icon" +
            (contactBody.type === "COMPANY" ||
            editContactBody?.type === "COMPANY"
              ? " active"
              : "")
          }
          style={{ cursor: "pointer" }}
          onClick={() => onClickTypeCompany()}
        >
          <FontAwesomeIcon icon={["far", "building"]} />
        </div>
      </div>
      <div
        style={{
          width: "57%",
          minWidth: 470,
          display:
            isEdit && editContactBody?.type === "PERSON" ? "none" : "block"
        }}
      >
        <div className="registry-form-field-text">
          <FormattedMessage id="addressBook.create.businessName.label" />
          {contactBody.type === "PERSON" || editContactBody?.type === "PERSON"
            ? ""
            : " *"}
        </div>
        <Input
          disabled={
            !isEdit
              ? contactBody.type === "PERSON"
              : editContactBody?.type === "PERSON"
          }
          tabIndex={1}
          className="registry-form-field-input"
          placeholder={intl.formatMessage({id:"addressBook.create.businessName.placeholder"})}
          onChange={e =>
            !isEdit
              ? setContactBody({ ...contactBody, description: e.target.value })
              : setEditContactBody({
                ...editContactBody,
                description: e.target.value
              })
          }
          value={
            !isEdit ? contactBody.description : editContactBody?.description
          }
        />
      </div>
      <div style={{ width: "33%", minWidth: 330 }}>
        <div className="registry-form-field-text"><FormattedMessage id="addressBook.create.country.label" /> *</div>
        <Select
          tabIndex={2}
          getPopupContainer={trigger => trigger.parentNode}
          showSearch
          style={{ width: "100%" }}
          className="registry-form-field-select"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
          placeholder={intl.formatMessage({id:"addressBook.create.country.placeholder"})}
          onChange={e => (!isEdit ? setCountry(e) : onEditCountry(e))}
          value={!isEdit && country ? country : editAddress?.country}
        >
          {optionCountries}
        </Select>
      </div>
    </div>
  );
};

export default RegistryFormHeader;
